import React, { useEffect, useState, Key } from 'react'
import { FieldErrors, UseFormRegister, UseFormWatch } from 'react-hook-form'
import { AppraisalFormProps } from '../../../Interface/EmployeeManager/AppraisalForm/AppraisalForm'

import { useStepTwo } from 'Hooks/useStepTwo'
import { ApStepTwoDesktop } from './ApStepTwoDesktop'
import { ApStepTwoMobile } from './ApStepTwoMobile'

export interface ApTextareaProps {
  kpLength?: number
  register: UseFormRegister<any> // Replace `any` with your form's data type
  errors?: FieldErrors<AppraisalFormProps>
  isManager?: boolean
  isAdmin?: boolean
  isDisabled?: boolean
  watch: UseFormWatch<AppraisalFormProps> | undefined
  employeeId?: string
  preview?: boolean
  isManagerDraft?: boolean
  control: any
}
export interface matricType {
  id: number
  userId: string
  relevance: number
  metric: string
  createdAt: string
}

const ApStepTwo: React.FC<ApTextareaProps> = (props) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  const logic = useStepTwo({
    employeeId: props.employeeId,
    control: props.control,
  })

  return isMobile ? (
    <ApStepTwoMobile {...props} {...logic} />
  ) : (
    <ApStepTwoDesktop {...props} {...logic} />
  )
}

export default ApStepTwo